import React from 'react';
import { AuthProviderState } from 'shared/features/auth/authentication/providers/states/auth-provider-state';

const AuthProviderContext = React.createContext<AuthProviderState>({} as never);

export default AuthProviderContext;
